module.exports = __webpack_public_path__ + "img/maintenece_mood.042944db.png";